import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    IconButton,
    Button,
    Stack,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const ProveCarouselDialog = ({ open, onClose, proofs }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        if (currentIndex < proofs.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const currentProof = proofs[currentIndex];

    const getFileExtension = (url) => {
        const cleanUrl = url.split('?')[0];
        return cleanUrl.split('.').pop();
    };

    const isImage = (url) => {
        const ext = getFileExtension(url);
        return ['jpeg', 'jpg', 'png', 'gif'].includes(ext.toLowerCase());
    };

    const isVideo = (url) => {
        const ext = getFileExtension(url);
        return ['mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'webm'].includes(
            ext.toLowerCase()
        );
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Visualizar Comprovantes
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    {currentProof ? (
                        isImage(currentProof) ? (
                            <img
                                src={currentProof}
                                alt={`proof-${currentIndex}`}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '500px',
                                    margin: '20px 0',
                                    borderRadius: 8,
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                }}
                            />
                        ) : isVideo(currentProof) ? (
                            <video
                                src={currentProof}
                                controls
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '500px',
                                    margin: '20px 0',
                                    borderRadius: 8,
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                }}
                            />
                        ) : (
                            <Typography variant="body2" sx={{ color: 'gray' }}>
                                Arquivo não suportado.
                            </Typography>
                        )
                    ) : (
                        <Typography variant="body2" sx={{ color: 'gray' }}>
                            Nenhuma prova disponível.
                        </Typography>
                    )}

                    <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            disabled={currentIndex === 0}
                            onClick={handlePrevious}
                        >
                            Anterior
                        </Button>
                        <Button
                            variant="contained"
                            disabled={currentIndex === proofs.length - 1}
                            onClick={handleNext}
                        >
                            Próximo
                        </Button>
                    </Stack>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ProveCarouselDialog;
